import { getNextSortConfig } from "./dailySaleReportTableConfig";

export { getNextSortConfig };

export const CUSTOMER_REPORT_FIXED_COLUMNS = 5;

export const CUSTOMER_COLUMN_FIELDS = [
  null,
  "customer_id",
  "customer_name",
  "customer_group",
  "customer_mobile",
  "customer_email",
  "wishlist",
  "custom",
  "repair",
  "exchange",
  "sales",
];

const NUMERIC_FIELDS = new Set([
  "wishlist",
  "custom",
  "repair",
  "exchange",
  "sales",
]);

const getSortValue = (row, field) => {
  const value = row?.[field];
  if (value === null || value === undefined || value === "") return null;
  if (NUMERIC_FIELDS.has(field)) {
    const num = Number(value);
    return Number.isFinite(num) ? num : null;
  }
  return String(value).toLowerCase();
};

const compareValues = (left, right) => {
  if (left === null && right === null) return 0;
  if (left === null) return 1;
  if (right === null) return -1;
  if (typeof left === "number" && typeof right === "number") {
    return left - right;
  }
  return String(left).localeCompare(String(right), undefined, {
    sensitivity: "base",
    numeric: true,
  });
};

export const sortCustomerReportRows = (rows, sortConfig) => {
  if (!Array.isArray(rows) || !rows.length) return rows || [];
  if (!sortConfig?.columnIndex || sortConfig.columnIndex === 0) return rows;

  const field = CUSTOMER_COLUMN_FIELDS[sortConfig.columnIndex];
  if (!field) return rows;

  const direction = sortConfig.direction === "desc" ? -1 : 1;

  return [...rows].sort((rowA, rowB) => {
    const comparison = compareValues(
      getSortValue(rowA, field),
      getSortValue(rowB, field)
    );
    return comparison * direction;
  });
};
